/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {AnimaDireita} from '../../../_metronic/assets/animation/styles'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {ChartsWidget13} from '../../../_metronic/partials/widgets'
import {CardSystemWidgetLicenses} from './licenses/components/cards/CardSystemWidgetLicenses'
import {CardSystemWidgetContractCost} from './licenses/components/cards/CardSystemWidgetContract'
import {KTSVG} from '../../../_metronic/helpers'
import {Calendar, CalendarDateTemplateParams} from 'primereact/calendar'
import {Skeleton} from 'primereact/skeleton'
import axios from 'axios'
import {Link} from 'react-router-dom'
import {insertDataTime} from '../../../util/insertDataTime'

const API_URL = process.env.REACT_APP_API_URL || 'api'

const SgaWrapper: FC = () => {
  const intl = useIntl()
  const [cardCost2] = useState<any>({
    description: 'Produção', //titulo do card 1
    data_route: 'widgets/licenses/count_licenses', //rota da api
  })
  const [valorChart13, setValorChart13] = useState()
  const [labelChart13, setLabelChart13] = useState()

  const [totalLicenses, setTotalLicenses] = useState<any>()
  const [activeLicenses, setActiveLicenses] = useState<any>()

  const [totalCondicionante, setTotalCondicionante] = useState<any>()
  const [ProgressCondicionante, setProgressCondicionante] = useState<any>()

  const [totalActionPlans, setTotalActionPlans] = useState<any>()
  const [ProgressActionPlans, setProgressActionPlans] = useState<any>()

  const [arrayDaysLicenses, setArrayDaysLicenses] = useState<any>()
  const [arrayDaysCondicionante, setArrayDaysCondicionante] = useState<any>()
  const [arrayDaysAcao, setArrayDaysAcao] = useState<any>()

  const [licenseList, setLicenseList] = useState<any>()
  const [condicionanteList, setCondicionanteList] = useState<any>()
  const [actionList, setActionList] = useState<any>()

  const [month, setMonth] = useState<any>()
  const [year, setYear] = useState<any>()

  const dateTemplate = (
    date: any,
    dayArraysCondicionante?: any,
    dayArraysAcao?: any,
    dayArrayslicense?: any
  ) => {
    setMonth(date.month + 1)

    if (
      dayArraysCondicionante !== undefined &&
      dayArrayslicense !== undefined &&
      dayArraysAcao !== undefined
    ) {
      return (
        <div>
          {date.day}
          {dayArrayslicense?.includes(date.day) ? (
            <p
              style={{
                background: '#009EF7',
                borderRadius: '100%',
                width: '4px',
                height: '4px',
                marginBottom: '-4px',
                marginLeft: '0px',
              }}
            ></p>
          ) : (
            ''
          )}
          {dayArraysCondicionante?.includes(date.day) ? (
            <p
              style={{
                background: 'red',
                borderRadius: '100%',
                width: '4px',
                height: '4px',
                marginBottom: '-4px',
                marginLeft: '5px',
              }}
            ></p>
          ) : (
            ''
          )}
          {dayArraysAcao.includes(date.day) ? (
            <p
              style={{
                background: '#F6C000',
                borderRadius: '100%',
                width: '4px',
                height: '4px',
                marginLeft: '10px',
                marginBottom: '-4px',
              }}
            ></p>
          ) : (
            ''
          )}
        </div>
      )
    }

    return date.day
  }

  async function getReportsChart13(
    project_id?: string,
    entrepreneur_id?: string,
    enterprise_type_id?: string
  ): Promise<any> {
    let route = `
      ${API_URL}/sga/v1/widgets/licenses/licenses_by_document_situation?${
      project_id !== undefined ? `${project_id}` : ''
    }${entrepreneur_id !== undefined ? `&${entrepreneur_id}` : ''}${
      enterprise_type_id !== undefined ? `&${enterprise_type_id}` : ''
    }`

    const response = await axios.get<any>(route)
    setValorChart13(response.data?.datasets.values)
    setLabelChart13(response.data?.datasets.labels)
    return response.data
  }

  async function getReportsTotal() {
    let totalLicenses = `${API_URL}/sga/v1/widgets/licenses/count_licenses?`
    const license = await axios.get<any>(totalLicenses)
    setTotalLicenses(
      new Intl.NumberFormat('pt-BR', {
        style: 'decimal',
      }).format(license.data.datasets.values[0])
    )

    let totalCondicionante = `${API_URL}/sga/v1/widgets/conditionings/count_conditionings`
    const condicionante = await axios.get<any>(totalCondicionante)
    setTotalCondicionante(
      new Intl.NumberFormat('pt-BR', {
        style: 'decimal',
      }).format(condicionante.data.datasets.values[0])
    )

    let totalAcao = `${API_URL}/sga/v1/widgets/action_plans/count_action_plans`
    const acao = await axios.get<any>(totalAcao)

    setTotalActionPlans(
      new Intl.NumberFormat('pt-BR', {
        style: 'decimal',
      }).format(acao.data.datasets.values[0])
    )
  }

  async function getReportsStatus() {
    let routeLicense = `${API_URL}/sga/v1/widgets/licenses/licenses_by_status`
    let routeCondicionante = `${API_URL}/sga/v1/widgets/conditionings/conditioning_by_status`
    let routeActionPlan = `${API_URL}/sga/v1/widgets/action_plans/action_plan_by_status`

    const licenca = await axios.get<any>(routeLicense)
    const condicionante = await axios.get<any>(routeCondicionante)
    const acao = await axios.get<any>(routeActionPlan)

    setActiveLicenses(
      new Intl.NumberFormat('pt-BR', {
        style: 'decimal',
      }).format(licenca.data.datasets.values.Válidas)
    )
    setProgressCondicionante(
      new Intl.NumberFormat('pt-BR', {
        style: 'decimal',
      }).format(condicionante.data.datasets.values[0])
    )
    setProgressActionPlans(
      new Intl.NumberFormat('pt-BR', {
        style: 'decimal',
      }).format(acao.data.datasets.values[0])
    )
  }

  async function getCalendarList(month?: any, year?: any) {
    let license = `${API_URL}/sga/v1/widgets/licenses/list_licenses?${
      year !== undefined ? `&year=${year}` : ''
    }${month !== undefined ? `&month=${month}` : ''}`

    let condicionante = `${API_URL}/sga/v1/widgets/conditionings/list_conditionings?${
      year !== undefined ? `&year=${year}` : ''
    }${month !== undefined ? `&month=${month}` : ''}`

    let acao = `${API_URL}/sga/v1/widgets/action_plans/list_action_plans?${
      year !== undefined ? `&year=${year}` : ''
    }${month !== undefined ? `&month=${month}` : ''}`

    const licenseResponse = await axios.get<any>(license)
    const condicionanteResponse = await axios.get<any>(condicionante)
    const acaoResponse = await axios.get<any>(acao)

    setLicenseList(licenseResponse.data.datasets.values)
    setCondicionanteList(condicionanteResponse.data.datasets.values)
    setActionList(acaoResponse.data.datasets.values)

    getCalendarCard(month, year)
  }

  async function getCalendarCard(month?: any, year?: any) {
    let condicionante = `${API_URL}/sga/v1/widgets/conditionings/conditioning_expirations_per_month?${
      year !== undefined ? `&year=${year}` : ''
    }${month !== undefined ? `&month=${month}` : ''}`

    let license = `${API_URL}/sga/v1/widgets/licenses/licenses_expirations_per_month?${
      year !== undefined ? `&year=${year}` : ''
    }${month !== undefined ? `&month=${month}` : ''}`

    const licenseResponse = await axios.get<any>(license)
    const condicionanteResponse = await axios.get<any>(condicionante)

    setArrayDaysLicenses(licenseResponse.data.datasets.labels.license_day)
    setArrayDaysCondicionante(condicionanteResponse.data.datasets.labels.conditioning_day)
    setArrayDaysAcao(condicionanteResponse.data.datasets.labels.action_plan_day)
  }

  useEffect(() => {
    getReportsChart13()
    getReportsTotal()
    getReportsStatus()
    getCalendarList(month, year)
  }, [])

  useEffect(() => {
    getCalendarList(month, year)
    // react-hooks/exhaustive-deps
  }, [month])
  insertDataTime()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'TEXT.SGA'})}</PageTitle>
      <AnimaDireita>
        <div className='row'>
          <div className='col-12 col-xxl-4 col-xl-6 col-lg-6 mt-5 mt-sm-3 mt-lg-0 order-1 order-xl-1'>
            <CardSystemWidgetContractCost
              title={'Licença'}
              subtitle1='Total de Licenças'
              subtitle2='Licenças Validas'
              total={totalLicenses}
              total2={activeLicenses}
              color='info'
            />
            <CardSystemWidgetContractCost
              title={'Condicionantes'}
              subtitle1='Total de Condicionantes'
              subtitle2='C. em Atendimento'
              total={totalCondicionante}
              total2={ProgressCondicionante}
              color='info'
            />
            <CardSystemWidgetContractCost
              title={'Planos de Ação'}
              subtitle1='Total de Planos de Ação'
              subtitle2='Planos em Atendimento'
              total={totalActionPlans}
              total2={ProgressActionPlans}
              color='info'
            />
          </div>

          <div className='col-12 col-xxl-4 col-xl-12 col-lg-12 mt-5 mt-sm-3 mt-lg-0 order-3  order-xl-3 order-xxl-2 '>
            {valorChart13 !== undefined ? (
              <ChartsWidget13 className='' value={valorChart13} label={labelChart13} />
            ) : (
              <div className='card row w-100 ms-1 h-100'>
                <h5 className='card-title align-items-start flex-column pt-5 px-8 pb-0'>
                  <span className='card-label fw-bolder mb-1'>Licenças Renovadas</span>
                </h5>
                <div className='d-flex justify-content-center align-content-end align-items-end mt-5'>
                  <Skeleton width='15px' height='25px' className=' ms-5'></Skeleton>
                  <Skeleton width='15px' height='50px' className=' ms-5'></Skeleton>
                  <Skeleton width='15px' height='100px' className=' ms-5'></Skeleton>
                  <Skeleton width='15px' height='250px' className=' ms-5'></Skeleton>
                  <Skeleton width='15px' height='200px' className=' ms-5'></Skeleton>
                  <Skeleton width='15px' height='150px' className=' ms-5'></Skeleton>
                  <Skeleton width='15px' height='200px' className=' ms-5'></Skeleton>
                  <Skeleton width='15px' height='250px' className=' ms-5'></Skeleton>
                  <Skeleton width='15px' height='200px' className=' ms-5'></Skeleton>
                  <Skeleton width='15px' height='150px' className=' ms-5'></Skeleton>
                  <Skeleton width='15px' height='200px' className=' ms-5'></Skeleton>
                  <Skeleton width='15px' height='150px' className=' ms-5'></Skeleton>
                  <Skeleton width='15px' height='100px' className=' ms-5'></Skeleton>
                  <Skeleton width='15px' height='50px' className=' ms-5'></Skeleton>
                  <Skeleton width='15px' height='25px' className=' ms-5'></Skeleton>
                </div>
                <Skeleton
                  height='5px'
                  className='d-flex justify-content-center align-content-end align-items-end'
                ></Skeleton>
              </div>
            )}
          </div>
          <div className='col-12 col-xxl-4 col-xl-6 col-lg-6 mt-5 mt-sm-3 mt-lg-0 order-2 order-xl-2 order-xxl-3 '>
            <CardSystemWidgetLicenses
              title={'Emissão'}
              route={'widgets/licenses/licenses_per_issue_cost_by_year'}
              color='success'
            />
            <CardSystemWidgetLicenses
              title={'Renovação'}
              route={'widgets/licenses/licenses_per_renovation_cost_by_year'}
              color='info'
            />
          </div>

          <div className='col-12  mt-3 order-4'>
            <div className='card'>
              {/* begin::Header */}
              <div className='card-header border-0'>
                <h4 className='card-title d-flex align-items-start flex-column'>
                  <span className='card-label fw-bolder text-gray-800'>
                    Calendário de Vencimentos
                  </span>
                  <span className='text-gray-400 mt-1 fw-bolder fs-7'>
                    Vencimentos nos Proximos 30 dias
                  </span>
                </h4>
              </div>
              {/* end::Header */}

              <div className='row px-3'>
                <Calendar
                  className='d-flex col-12 col-lg-12 col-xl-12 col-xxl-3 mb-5 justify-content-lg-center'
                  id='datetemplate'
                  inline
                  dateTemplate={(e: CalendarDateTemplateParams) =>
                    dateTemplate(e, arrayDaysCondicionante, arrayDaysAcao, arrayDaysLicenses)
                  }
                  showOtherMonths={false}
                />

                <div className='col-4 col-lg-4 col-xl-4 col-xxl-3'>
                  <Link
                    to='/licenses'
                    className='btn btn-light-primary btn-active-light-primary mb-3'
                  >
                    Licenças
                  </Link>
                  <div className='w-auto h-350px overflow-auto'>
                    {licenseList !== undefined ? (
                      <div>
                        {licenseList.length > 0 ? (
                          <div>
                            {licenseList.map((license: any) => {
                              return (
                                <div
                                  key={license.uuid}
                                  className='d-flex align-items-center bg-light rounded p-5 mb-7 w-100'
                                >
                                  <span className='svg-icon svg-icon-success me-3'>
                                    <KTSVG
                                      path='/media/icons/duotune/coding/cod002.svg'
                                      className='svg-icon-1'
                                    />
                                  </span>

                                  <div className='flex-grow-1 me-2 '>
                                    <strong className='fs-8'>
                                      Licença
                                      <Link
                                        to={`/editlicenses/${license.id}/${license.uuid}`}
                                        className='fw-bolder'
                                      >
                                        {' '}
                                        {license.license_number}
                                      </Link>
                                    </strong>

                                    <span className='text-muted fs-8 fw-bold d-block'>
                                      O limite de renovação termina em {license.days_remaining} dias
                                    </span>
                                  </div>
                                </div>
                              )
                            })}
                          </div>
                        ) : (
                          <div
                            className='d-flex'
                            style={{
                              maxHeight: '350px',
                              minHeight: '350px',
                            }}
                          >
                            {/* begin::Item */}
                            <div className='d-flex align-items-center bg-light rounded p-5 mb-7 w-100'>
                              {/* begin::Icon */}

                              {/* begin::Title */}
                              <div className='flex-grow-1 me-2 text-center '>
                                <strong className='fs-7'>
                                  Não existem vencimentos para este mês
                                </strong>
                              </div>
                              {/* end::Title */}
                            </div>
                            {/* end::Item */}
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className='card row ms-5'>
                        <div className='d-flex justify-content-between mb-3'>
                          <Skeleton size='4rem' className='d-flex '></Skeleton>
                          <div>
                            <Skeleton width='250px' className='mb-2'></Skeleton>
                            <Skeleton width='50%' className='mb-2'></Skeleton>
                          </div>
                          <Skeleton size='3rem' className='d-flex justify-content-end'></Skeleton>
                        </div>
                        <div className='d-flex justify-content-between mb-3'>
                          <Skeleton size='4rem' className='d-flex '></Skeleton>
                          <div>
                            <Skeleton width='250px' className='mb-2'></Skeleton>
                            <Skeleton width='50%' className='mb-2'></Skeleton>
                          </div>
                          <Skeleton size='3rem' className='d-flex justify-content-end'></Skeleton>
                        </div>
                        <div className='d-flex justify-content-between mb-3'>
                          <Skeleton size='4rem' className='d-flex '></Skeleton>
                          <div>
                            <Skeleton width='250px' className='mb-2'></Skeleton>
                            <Skeleton width='50%' className='mb-2'></Skeleton>
                          </div>
                          <Skeleton size='3rem' className='d-flex justify-content-end'></Skeleton>
                        </div>
                        <div className='d-flex justify-content-between mb-3'>
                          <Skeleton size='4rem' className='d-flex '></Skeleton>
                          <div>
                            <Skeleton width='250px' className='mb-2'></Skeleton>
                            <Skeleton width='50%' className='mb-2'></Skeleton>
                          </div>
                          <Skeleton size='3rem' className='d-flex justify-content-end'></Skeleton>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className='col-4 col-lg-4 col-xl-4 col-xxl-3'>
                  <Link
                    to='/conditioning'
                    className='btn btn-light-primary btn-active-light-primary mb-3'
                  >
                    Condicionantes
                  </Link>

                  <div className='w-auto h-350px overflow-auto'>
                    {condicionanteList !== undefined ? (
                      <div>
                        {condicionanteList.length > 0 ? (
                          <div>
                            {condicionanteList.map((condicionante: any) => {
                              return (
                                <div
                                  className='d-flex align-items-center bg-light-warning rounded p-5 mb-7 w-100'
                                  key={condicionante.conditioning_id}
                                >
                                  <span className='svg-icon svg-icon-success me-5'>
                                    <KTSVG
                                      path='/media/icons/duotune/general/gen005.svg'
                                      className='svg-icon-1'
                                    />
                                  </span>

                                  <div className='flex-grow-1 me-2 '>
                                    <p className='fw-bold fs-8 mb-0'>
                                      Licença Nº{' '}
                                      <Link
                                        to={`/editlicenses/${condicionante.license_id}/${condicionante.license_uuid}`}
                                        className='fw-bolder'
                                      >
                                        {' '}
                                        {condicionante.license_number}
                                      </Link>
                                    </p>

                                    <p className='fw-bold fs-8 mb-0'>
                                      Condicionante Nº
                                      <Link
                                        to={`/editconditioning/${condicionante.license_id}/${condicionante.conditioning_uuid}/${condicionante.license_uuid}`}
                                        className='fw-bolder'
                                      >
                                        {' '}
                                        {condicionante.conditioning_number}
                                      </Link>
                                    </p>

                                    {condicionante.days_remaining > 0 ? (
                                      <span className='text-success fs-8 fw-bold d-block'>
                                        Vencimento em {condicionante.days_remaining} dias
                                      </span>
                                    ) : (
                                      <span className='text-danger fs-8 fw-bold d-block'>
                                        {`Venceu há ${condicionante.days_remaining
                                          .toString()
                                          .replaceAll('-', '')} dias.`}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              )
                            })}
                          </div>
                        ) : (
                          <div
                            className='d-flex'
                            style={{
                              maxHeight: '350px',
                              minHeight: '350px',
                            }}
                          >
                            <div className='d-flex align-items-center bg-light rounded p-5 mb-7 w-100'>
                              <div className='flex-grow-1 me-2 text-center '>
                                <strong className='fs-7'>
                                  Não existem vencimentos para este mês
                                </strong>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className='card row ms-5'>
                        <div className='d-flex justify-content-between mb-3'>
                          <Skeleton size='4rem' className='d-flex '></Skeleton>
                          <div>
                            <Skeleton width='250px' className='mb-2'></Skeleton>
                            <Skeleton width='50%' className='mb-2'></Skeleton>
                          </div>
                          <Skeleton size='3rem' className='d-flex justify-content-end'></Skeleton>
                        </div>
                        <div className='d-flex justify-content-between mb-3'>
                          <Skeleton size='4rem' className='d-flex '></Skeleton>
                          <div>
                            <Skeleton width='250px' className='mb-2'></Skeleton>
                            <Skeleton width='50%' className='mb-2'></Skeleton>
                          </div>
                          <Skeleton size='3rem' className='d-flex justify-content-end'></Skeleton>
                        </div>
                        <div className='d-flex justify-content-between mb-3'>
                          <Skeleton size='4rem' className='d-flex '></Skeleton>
                          <div>
                            <Skeleton width='250px' className='mb-2'></Skeleton>
                            <Skeleton width='50%' className='mb-2'></Skeleton>
                          </div>
                          <Skeleton size='3rem' className='d-flex justify-content-end'></Skeleton>
                        </div>
                        <div className='d-flex justify-content-between mb-3'>
                          <Skeleton size='4rem' className='d-flex '></Skeleton>
                          <div>
                            <Skeleton width='250px' className='mb-2'></Skeleton>
                            <Skeleton width='50%' className='mb-2'></Skeleton>
                          </div>
                          <Skeleton size='3rem' className='d-flex justify-content-end'></Skeleton>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className='col-4 col-lg-4 col-xl-4 col-xxl-3'>
                  <Link
                    to='/actionplans'
                    className='btn btn-light-primary btn-active-light-primary mb-3'
                  >
                    Plano de Ação
                  </Link>
                  <div className='w-auto h-350px overflow-auto'>
                    {actionList !== undefined ? (
                      <div>
                        {actionList.length > 0 ? (
                          <div>
                            {actionList.map((actionPlan: any) => {
                              return (
                                <div
                                  className='d-flex align-items-center bg-light-danger rounded p-5 mb-7 w-100'
                                  key={actionPlan.conditioning_id}
                                >
                                  <span className='svg-icon svg-icon-success me-5'>
                                    <KTSVG
                                      path='/media/icons/duotune/general/gen005.svg'
                                      className='svg-icon-1'
                                    />
                                  </span>

                                  <div className='flex-grow-1 me-2 '>
                                    <p className='fw-bold fs-8 mb-0'>
                                      {`Ação Nº ${actionPlan.action_plan_id}`}
                                    </p>
                                    <p className='fw-bold fs-8 mb-0'>
                                      Condicionante Nº
                                      <Link
                                        to={`/editconditioning/${actionPlan.license_id}/${actionPlan.conditioning_uuid}/${actionPlan.license_uuid}`}
                                        className='fw-bolder'
                                      >
                                        {' '}
                                        {actionPlan.conditioning_number}
                                      </Link>
                                    </p>
                                    <p className='fw-bold fs-8 mb-0'>
                                      Licença Nº{' '}
                                      <Link
                                        to={`/editlicenses/${actionPlan.license_id}/${actionPlan.license_uuid}`}
                                        className='fw-bolder'
                                      >
                                        {' '}
                                        {actionPlan.license_number}
                                      </Link>
                                    </p>

                                    {actionPlan.days_remaining > 0 ? (
                                      <span className='text-success fs-8 fw-bold d-block'>
                                        Vencimento em {actionPlan.days_remaining} dias
                                      </span>
                                    ) : (
                                      <span className='text-danger fs-8 fw-bold d-block'>
                                        {`Venceu há ${actionPlan.days_remaining
                                          .toString()
                                          .replaceAll('-', '')} dias.`}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              )
                            })}
                          </div>
                        ) : (
                          <div
                            className='d-flex'
                            style={{
                              maxHeight: '350px',
                              minHeight: '350px',
                            }}
                          >
                            <div className='d-flex align-items-center bg-light rounded p-5 mb-7 w-100'>
                              <div className='flex-grow-1 me-2 text-center '>
                                <strong className='fs-7'>
                                  Não existem vencimentos para este mês
                                </strong>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className='card row ms-5'>
                        <div className='d-flex justify-content-between mb-3'>
                          <Skeleton size='4rem' className='d-flex '></Skeleton>
                          <div>
                            <Skeleton width='250px' className='mb-2'></Skeleton>
                            <Skeleton width='50%' className='mb-2'></Skeleton>
                          </div>
                          <Skeleton size='3rem' className='d-flex justify-content-end'></Skeleton>
                        </div>
                        <div className='d-flex justify-content-between mb-3'>
                          <Skeleton size='4rem' className='d-flex '></Skeleton>
                          <div>
                            <Skeleton width='250px' className='mb-2'></Skeleton>
                            <Skeleton width='50%' className='mb-2'></Skeleton>
                          </div>
                          <Skeleton size='3rem' className='d-flex justify-content-end'></Skeleton>
                        </div>
                        <div className='d-flex justify-content-between mb-3'>
                          <Skeleton size='4rem' className='d-flex '></Skeleton>
                          <div>
                            <Skeleton width='250px' className='mb-2'></Skeleton>
                            <Skeleton width='50%' className='mb-2'></Skeleton>
                          </div>
                          <Skeleton size='3rem' className='d-flex justify-content-end'></Skeleton>
                        </div>
                        <div className='d-flex justify-content-between mb-3'>
                          <Skeleton size='4rem' className='d-flex '></Skeleton>
                          <div>
                            <Skeleton width='250px' className='mb-2'></Skeleton>
                            <Skeleton width='50%' className='mb-2'></Skeleton>
                          </div>
                          <Skeleton size='3rem' className='d-flex justify-content-end'></Skeleton>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className='row px-3 mt-n5'>
                <div className='col-6'>
                  <div className='col-4'>
                    <span
                      className='badge badge-circle badge-primary fs-9'
                      style={{
                        height: '10px',
                        width: '10px',
                      }}
                    >
                      {''}
                    </span>
                    <span className='fw-semibold fs-8 ms-1'>Vencimento de Licença</span>
                  </div>
                  <div className='col-4'>
                    <span
                      className='badge badge-circle badge-danger fs-9'
                      style={{
                        height: '10px',
                        width: '10px',
                      }}
                    >
                      {''}
                    </span>
                    <span className='fw-semibold fs-8 ms-1'>Vencimento de Condicionante</span>
                  </div>
                  <div className='col-4'>
                    <span
                      className='badge badge-circle badge-warning fs-9'
                      style={{
                        height: '10px',
                        width: '10px',
                      }}
                    >
                      {''}
                    </span>
                    <span className='fw-semibold fs-8 ms-1'>Vencimento de Ação</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </AnimaDireita>
    </>
  )
}

export {SgaWrapper}
